export default __webpack_public_path__ + "static/media/acv.0a2817f9.png";